// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1yz_v","label":"CategoryService_label__1o4Q3","location":"CategoryService_location__2bBoY"};